import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Row, Spin, Typography } from 'antd';
import { api } from '../../services/api';
import CreateTenantModal from './CreateTenantModal';
import PlatformIntegrationsPanel from './PlatformIntegrationsPanel';
import PlatformTenantsList from './PlatformTenantsList';

const { Title, Text } = Typography;

const METRIC_CARDS = [
  { key: 'total_tenants', title: 'Total Tenants' },
  { key: 'active_tenants', title: 'Ativos' },
  { key: 'trial_tenants', title: 'Trial' },
  { key: 'inactive_tenants', title: 'Inativos' },
  { key: 'tenants_without_subscription', title: 'Sem assinatura' },
];

const PlatformDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [metrics, setMetrics] = useState({
    total_tenants: 0,
    active_tenants: 0,
    trial_tenants: 0,
    inactive_tenants: 0,
    tenants_without_subscription: 0,
  });

  const loadDashboard = useCallback(async () => {
    setLoading(true);
    setError('');

    try {
      const response = await api.get('/api/platform-admin/dashboard');
      setMetrics({
        total_tenants: Number(response.data?.total_tenants || 0),
        active_tenants: Number(response.data?.active_tenants || 0),
        trial_tenants: Number(response.data?.trial_tenants || 0),
        inactive_tenants: Number(response.data?.inactive_tenants || 0),
        tenants_without_subscription: Number(response.data?.tenants_without_subscription || 0),
      });
    } catch (requestError) {
      console.error(requestError);
      setError('Nao foi possivel carregar o dashboard da plataforma.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadDashboard();
  }, [loadDashboard, refreshKey]);

  const handleTenantCreated = () => {
    setRefreshKey((prev) => prev + 1);
  };

  if (loading) {
    return (
      <div style={{ minHeight: 280, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spin size="large" tip="Carregando dashboard da plataforma..." />
      </div>
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <Title level={2} style={{ marginTop: 0 }}>
        Painel da Plataforma
      </Title>
      <Text type="secondary">Resumo SaaS por tenants e assinaturas</Text>

      <div style={{ marginTop: 16 }}>
        <Button type="primary" onClick={() => setIsCreateModalOpen(true)}>
          Novo Tenant
        </Button>
      </div>

      {error ? (
        <Alert
          type="error"
          showIcon
          message="Erro ao carregar"
          description={error}
          style={{ marginTop: 16, marginBottom: 16 }}
        />
      ) : null}

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        {METRIC_CARDS.map((item) => (
          <Col xs={24} sm={12} lg={8} xl={4} key={item.key}>
            <Card>
              <Text type="secondary">{item.title}</Text>
              <div style={{ fontSize: 32, fontWeight: 700, lineHeight: 1.2, marginTop: 8 }}>
                {metrics[item.key]}
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <PlatformIntegrationsPanel />

      <PlatformTenantsList refreshKey={refreshKey} />

      <CreateTenantModal
        open={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onCreated={handleTenantCreated}
      />
    </div>
  );
};

export default PlatformDashboard;
